// src/utils/utils.js
function onDOMReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

export function enhanceColorPalettes() {
  onDOMReady(() => {
    const colorlists = document.querySelectorAll('[data-list="colors"]');

    if (colorlists.length === 0) return;

    let activeElement = null;
    let activeCopyElement = null;

    function addSvg(parent) {
      const svgWrap = document.createElement('div');
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', true);
      svg.innerHTML =
        '<path d="M22.4953 6.67969L21.4078 7.71094L9.98438 18.5297L8.95312 19.5047L7.92188 18.5297L2.5875 13.4813L1.5 12.45L3.5625 10.2703L4.65 11.3016L8.95312 15.375L19.3453 5.53125L20.4328 4.5L22.4953 6.67969Z" fill="currentColor"/>';
      svgWrap.appendChild(svg);
      parent.appendChild(svgWrap);
    }

    function rgbToHex(rgbString) {
      const parts = rgbString.split(',');
      const r = parseInt(parts[0].trim());
      const g = parseInt(parts[1].trim());
      const b = parseInt(parts[2].trim());
      // Falls ein Alpha-Wert vorhanden ist
      if (parts.length === 4) {
        let alpha = parseFloat(parts[3].trim());
        // Wenn alpha 1 (vollständig undurchsichtig) ist, bleibt es ein 6-stelliger HEX-Code.
        if (alpha >= 1) {
          return '#' + [r, g, b].map((c) => c.toString(16).padStart(2, '0')).join('');
        } else {
          const aHex = Math.round(alpha * 255)
            .toString(16)
            .padStart(2, '0');
          return '#' + [r, g, b].map((c) => c.toString(16).padStart(2, '0')).join('') + aHex;
        }
      } else {
        return '#' + [r, g, b].map((c) => c.toString(16).padStart(2, '0')).join('');
      }
    }

    colorlists.forEach((colorlist) => {
      const colorItems = colorlist.querySelectorAll('li');

      if (colorItems.length === 0) return;

      colorItems.forEach((colorItem) => {
        const popover = document.createElement('div');
        popover.className = 'popover';

        // Get Background Color
        const rgbColor = window.getComputedStyle(colorItem).getPropertyValue('background-color');
        let rgbValues;
        let isRgba = false;
        if (rgbColor.startsWith('rgba(')) {
          // Bei rgba: "rgba(" hat 5 Zeichen
          rgbValues = rgbColor.substring(5, rgbColor.length - 1);
          isRgba = true;
        } else if (rgbColor.startsWith('rgb(')) {
          // Bei rgb: "rgb(" hat 4 Zeichen
          rgbValues = rgbColor.substring(4, rgbColor.length - 1);
        } else {
          rgbValues = rgbColor;
        }

        const rgbElement = document.createElement('div');
        rgbElement.setAttribute('style', 'position: relative;');
        rgbElement.innerHTML = `<strong>${isRgba ? 'RGBA' : 'RGB'}:</strong> ${rgbValues}`;
        addSvg(rgbElement);
        popover.appendChild(rgbElement);

        // Generate HEX
        const hexValue = rgbToHex(rgbValues);
        const hexElement = document.createElement('div');
        hexElement.setAttribute('style', 'position: relative;');
        hexElement.innerHTML = `<strong>HEX:</strong> ${hexValue}`;
        addSvg(hexElement);
        popover.appendChild(hexElement);

        const cssVarValue = colorItem.getAttribute('data-css-var');
        let cssVar = '';
        let cssElement = null;

        if (cssVarValue && cssVarValue.trim() !== '') {
          if (cssVarValue.startsWith('var(') && cssVarValue.endsWith(')')) {
            cssVar = cssVarValue.slice(4, -1).trim();
          } else {
            cssVar = cssVarValue;
          }
          // Erzeugen und Hinzufügen eines weiteren Elements mit dem CSS-Wert
          cssElement = document.createElement('div');
          cssElement.setAttribute('style', 'position: relative;');
          cssElement.innerHTML = `<strong>CSS:</strong> ${cssVar}`;
          addSvg(cssElement);
          popover.appendChild(cssElement);
        }

        colorItem.appendChild(popover);

        // Klick-Event: Unterscheidung zwischen normalem Klick und STRG+Klick
        colorItem.addEventListener('click', (event) => {
          let textToCopy, copyPopoverElement;
          if (event.altKey) {
            // Alt/Option-Klick: Kopiert den HEX-Wert
            textToCopy = hexValue;
            copyPopoverElement = hexElement;
          } else if (event.ctrlKey && cssElement) {
            // STRG-Klick: Kopiert den data-css-var Wert
            textToCopy = cssVarValue;
            copyPopoverElement = cssElement;
          } else {
            // Standard: Kopiert den vollständigen RGB(A)-Wert
            textToCopy = rgbColor;
            copyPopoverElement = rgbElement;
          }

          // Kopieren des Wertes in die Zwischenablage
          navigator.clipboard
            .writeText(textToCopy)
            .then(() => {
              // Entferne vorherige "is-active" Klassen, falls vorhanden
              if (activeElement) {
                activeElement.classList.remove('is-active');
              }
              activeElement = colorItem;
              colorItem.classList.add('is-active');
              setTimeout(() => {
                colorItem.classList.remove('is-active');
              }, 2000);

              if (activeCopyElement) {
                activeCopyElement.classList.remove('is-active');
              }
              activeCopyElement = copyPopoverElement;
              copyPopoverElement.classList.add('is-active');
              setTimeout(() => {
                copyPopoverElement.classList.remove('is-active');
              }, 2000);
            })
            .catch((err) => {
              console.error('Copy failed: ', err);
            });
        });
      });
    });
  });
}

export function enhanceIconList() {
  onDOMReady(() => {
    const iconlists = document.querySelectorAll('[data-list="icons"]');

    if (iconlists.length === 0) return;

    let activeCopyElement = null;

    function addSvg(parent) {
      const svgWrap = document.createElement('div');
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('aria-hidden', true);
      svg.innerHTML =
        '<path d="M22.4953 6.67969L21.4078 7.71094L9.98438 18.5297L8.95312 19.5047L7.92188 18.5297L2.5875 13.4813L1.5 12.45L3.5625 10.2703L4.65 11.3016L8.95312 15.375L19.3453 5.53125L20.4328 4.5L22.4953 6.67969Z" fill="currentColor"/>';
      svgWrap.appendChild(svg);
      parent.appendChild(svgWrap);
    }

    iconlists.forEach((iconList) => {
      const iconItems = iconList.querySelectorAll('svg');

      if (iconItems.length === 0) return;

      iconItems.forEach((iconItem) => {
        const parent = iconItem.parentElement;
        const popover = document.createElement('div');
        const useElement = iconItem.querySelector('use');
        popover.className = 'popover';

        // Get Icon Name
        const iconName = useElement.href.baseVal;

        const nameElement = document.createElement('div');
        nameElement.setAttribute('style', 'position: relative;');
        nameElement.innerHTML = `<strong>Icon:</strong> ${iconName}`;
        addSvg(nameElement);
        popover.appendChild(nameElement);

        parent.appendChild(popover);

        // Klick-Event: Unterscheidung zwischen normalem Klick und STRG+Klick
        parent.addEventListener('click', (event) => {
          const textToCopy = iconName;
          const copyPopoverElement = nameElement;

          // Kopieren des Wertes in die Zwischenablage
          navigator.clipboard
            .writeText(textToCopy)
            .then(() => {
              // Entferne vorherige "is-active" Klassen, falls vorhanden
              if (activeCopyElement) {
                activeCopyElement.classList.remove('is-active');
              }
              activeCopyElement = copyPopoverElement;
              copyPopoverElement.classList.add('is-active');
              setTimeout(() => {
                copyPopoverElement.classList.remove('is-active');
              }, 2000);
            })
            .catch((err) => {
              console.error('Copy failed: ', err);
            });
        });
      });
    });
  });

}
